import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import { QrsOnset } from '../../ecg/types/qrs-onset.type';
import * as undoActions from '../../undo/actions/undo.actions';
import * as scatterActions from '../actions/scatter.actions';

declare module 'react-redux' {
  interface DefaultRootState {
    scatter: ScatterState;
  }
}

export interface ScatterState {
  onsets: QrsOnset[];
  loaded: boolean;
}

const initialStateFactory = (): ScatterState => ({
  onsets: [],
  loaded: false,
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    scatterActions.load,
    (_state, { onsets }): ScatterState => ({
      onsets,
      loaded: true,
    }),
  ),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { scatter } }): ScatterState => {
      if (!scatter) {
        return state;
      }
      return { ...state, ...scatter };
    },
  ),
);
